module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M.018 20c.002.52.186 1.032.568 1.414l10 10c.38.382.892.566 1.414.566V32h18c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v18h.018zM4 4h24v24H14v-8c0-1.106-.894-2-2-2H4V4zm20.894 2h-7.748c-1.222 0-1.514.702-.648 1.564l2.554 2.556-4.466 4.466a1 1 0 0 0 0 1.414L16 17.414a1 1 0 0 0 1.414 0l4.466-4.466 2.554 2.554c.866.866 1.566.576 1.566-.648V7.108C26 6.494 25.504 6 24.894 6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/turn-page-up-1.js
// module id = 1462
// module chunks = 14